<template>
  <v-app>
    <v-dialog
          v-model="dialog"
          scrollable
          max-width="600px"
      >
        <v-card>
          <v-toolbar dark>
            <v-card-title>{{ `${edit ? 'Update' : 'Add'} shelf` }}</v-card-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
              <v-spacer></v-spacer>
              <v-btn icon  @click="reset">
                <i class="fas fa-times"></i>
              </v-btn>
            </v-toolbar-items>
          </v-toolbar>
          <v-divider></v-divider>
          <v-card-text>
            <v-container>
              <div class="row">
                <div class="col-12 ">
                  <v-text-field type="text" outlined dense label="Title" v-model="shelf.title"></v-text-field>
                  <span class="text-danger" v-if="$v.shelf.title.$error">Title is required</span>
                </div>
                <div class="col-12 ">
                  <v-textarea cols="30" rows="10" outlined dense v-model="shelf.description"
                              placeholder="Description"></v-textarea>
                </div>
                <div class="col-12 ">
                  Status
                  <v-switch
                      v-model="shelf.is_active"
                      :label="shelf.is_active?'Active':'Inactive'">Status
                  </v-switch>
                </div>
              </div>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <div class="row">
              <div class="col-12 text-right">
                <v-btn
                    class="btn btn-standard cancel-btn"
                    depressed
                    @click="reset"
                >Cancel
                </v-btn>

                <v-btn v-if="checkIsAccessible('library-shelf', 'create')"
                       class="text-white ml-2 btn btn-primary"
                       depressed
                    @click="createOrUpdate"
                    :loading="isBusy"
                >Save
                </v-btn>
              </div>
            </div>
          </v-card-actions>
        </v-card>
      </v-dialog>
  </v-app>
</template>

<script>
import ShelfService from "@/core/services/library/shelf/ShelfService";
import {required} from "vuelidate/lib/validators";

const shelfService = new ShelfService();
export default {
  name: "CreateAndUpdate",
  props: ['dialog'],
  validations() {
    return {
      shelf: this.rules
    }
  },
  data() {
    return {
      shelf: {
        title: null,
        parent_id: null,
        is_active: true,
        description: null
      },
      isBusy: false,
      edit: false,
    }
  }, computed: {
    rules() {
      let rule = {
        title: {required}
      }
      return rule;
    }
  },
  methods: {
    createOrUpdate() {
      this.$v.$touch()
      if (this.$v.$error) {
        setTimeout(() => {
          this.$v.$reset();
        }, 3000)
      } else {
        if (this.shelf.id) {
          this.update();
        } else {
          this.save();
        }
      }
    },
    setValue(shelf = {}) {
      this.shelf = shelf
    },
    update() {
      this.isBusy = true
      shelfService
          .update(this.shelf.id, this.shelf)
          .then(response => {
            this.$snotify.success("Updated successfully")
            this.reset();
          }).catch(error => {
            console.log(error)
          }).finally(this.isBusy = false)
    },
    save() {
      this.isBusy = true;
      shelfService
          .store(this.shelf)
          .then(response => {
              this.$snotify.success("Created successfully")
              this.reset();
        })
          .catch(error => {
          console.log(error)
        })
          .finally(this.isBusy = false)
        },
    reset() {
      this.shelf = {
        title: null,
        parent_id: null,
        is_active: true,
        description: null
      }
      this.edit = false;
      this.$v.$reset();
      this.$emit("close_dialog")
    },
    createNewShelf(){
      this.edit=false;
    },
    editNewShelf(item){
      this.edit=true;
      this.shelf=item;
    },
  }
}
</script>

<style scoped>

</style>
